(function () {

  // 产品卡片右上角信息预览按钮
  document.addEventListener("click", function (e) {
    // 打开弹窗
    if (e.target.closest(".product-item-preview-btn")) {
      const previewBtn = e.target.closest(".product-item-preview-btn");
      const productItem = previewBtn.closest("product-item");
      const specEl = productItem.querySelector(".product-item-spec");
      if (specEl) {
        specEl.hidden = false;
      }
    }
    // 关闭弹窗
    if (e.target.closest(".llano-product-card__specs-close")) {
      const closeBtn = e.target.closest(".llano-product-card__specs-close");
      const productItem = closeBtn.closest("product-item");
      const specEl = productItem.querySelector(".product-item-spec");
      if (specEl) {
        specEl.hidden = true;
      }
    }
  });

  // Filter 展示收缩
  document.addEventListener('click', function(e) {
    // 点击 product-facet__filters-header
    if (e.target.closest('.product-facet__filters-header')) {
      const headerEl = e.target.closest('.product-facet__filters-header');
      const facetWrap = headerEl.closest('.product-facet');
      const asideEl = facetWrap.querySelector('.product-facet__aside');
      const openBtn = facetWrap.querySelector('.open-filter-btn');
      const productListInner = document.querySelector('.product-list__inner');

      if (asideEl) {
        asideEl.classList.add('hidden');
      }
      if (openBtn) {
        openBtn.classList.remove('hidden');
      }
      // 给商品列表添加 grid-4-items
      if(productListInner){
        productListInner.classList.add('grid-4-items');
      }
    }

    // 点击 open-filter-btn
    if (e.target.closest('.open-filter-btn')) {
      const openBtn = e.target.closest('.open-filter-btn');
      const facetWrap = openBtn.closest('.product-facet');
      const asideEl = facetWrap.querySelector('.product-facet__aside');
      const productListInner = document.querySelector('.product-list__inner');

      if (asideEl) {
        asideEl.classList.remove('hidden');
      }
      if (openBtn) {
        openBtn.classList.add('hidden');
      }
      // 移除 grid-4-items
      if(productListInner){
        productListInner.classList.remove('grid-4-items');
      }
    }
  })


  // 产品类型切换
  const PARAM_KEY = "filter.p.m.custom.filter_type";
  const list = document.querySelector(".filter-type-list");
  if (!list) return;

  function getFilterTextFromUrl() {
    const match = window.location.search.match(
      /filter\.p\.m\.custom\.filter_type=([^&]+)/,
    );
    if (!match) return "";
    return decodeURIComponent(match[1].replace(/\+/g, " "));
  }

  function setActiveFilter(targetOrText) {
    list.querySelectorAll(".filter-type-option").forEach((item) => {
      const isActive =
        typeof targetOrText === "string"
          ? item.textContent.trim() === targetOrText
          : item === targetOrText;
      item.classList.toggle("active", isActive);
    });
  }

  function buildFilterUrl(filterText) {
    const urlObj = new URL(window.location.href);
    urlObj.searchParams.delete(PARAM_KEY);
    urlObj.searchParams.delete("page");
    const filterValue = filterText.replace(/\s/g, "+");
    const baseQuery = urlObj.searchParams.toString();
    const newQuery = baseQuery
      ? baseQuery + "&" + PARAM_KEY + "=" + filterValue
      : PARAM_KEY + "=" + filterValue;
    return urlObj.origin + urlObj.pathname + "?" + newQuery;
  }

  function onUrlChange() {
    if (!getFilterTextFromUrl()) {
      setActiveFilter(list.querySelector(".filter-type-option"));
    }
  }

  const originalPushState = history.pushState;
  const originalReplaceState = history.replaceState;

  history.pushState = function () {
    originalPushState.apply(this, arguments);
    onUrlChange();
  };
  history.replaceState = function () {
    originalReplaceState.apply(this, arguments);
    onUrlChange();
  };
  window.addEventListener("popstate", onUrlChange);

  list.addEventListener("click", function (event) {
    const item = event.target.closest(".filter-type-option");
    if (!item || !list.contains(item)) return;

    const filterText = item.textContent.trim();
    const finalUrl = buildFilterUrl(filterText);
    setActiveFilter(item);

    const productFacet = document.querySelector("product-facet");
    if (productFacet) {
      productFacet.dispatchEvent(
        new CustomEvent("facet:criteria-changed", {
          bubbles: true,
          detail: { url: finalUrl },
        }),
      );
    } else {
      window.location.href = finalUrl;
    }
  });

  onUrlChange();

  
  // === 二级筛选项父子联动 ===
  // 父项为纯 UI 控制器（无 name，不参与 Shopify 提交）：
  //   - 勾选父项 → 勾选所有子项（只提交子项，触发一次筛选）
  //   - 勾选任一子项 → 父项视觉勾选；全部子项取消 → 父项取消
  function syncParentCheckbox(parentInput) {
    var container = parentInput.closest('.checkbox-container--parent');
    if (!container) return;
    var collapsible = container.nextElementSibling;
    if (!collapsible || !collapsible.classList.contains('collapsible--children')) return;
    var children = collapsible.querySelectorAll('input[data-child-checkbox]');
    parentInput.checked = Array.prototype.some.call(children, function (c) { return c.checked; });
  }

  function initNestedFilterVisuals() {
    var parents = document.querySelectorAll('input[data-parent-checkbox]');
    Array.prototype.forEach.call(parents, function (p) { syncParentCheckbox(p); });
  }

  // 事件委托（document 级别，DOM 重新渲染后依然有效）
  document.addEventListener('change', function (e) {
    // 父项变化：全选 / 取消所有子项
    var parentInput = e.target.closest ? e.target.closest('input[data-parent-checkbox]') : null;
    if (parentInput) {
      var container = parentInput.closest('.checkbox-container--parent');
      var collapsible = container ? container.nextElementSibling : null;
      if (!collapsible || !collapsible.classList.contains('collapsible--children')) return;
      var children = Array.prototype.slice.call(
        collapsible.querySelectorAll('input[data-child-checkbox]:not([disabled])')
      );
      var shouldCheck = parentInput.checked;
      children.forEach(function (child) { child.checked = shouldCheck; });
      // 只触发一次提交（在第一个子项上 dispatch change，主题监听 [name^="filter."]）
      if (children.length > 0) {
        children[0].dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // 子项变化：更新对应父项视觉状态
    var childInput = e.target.closest ? e.target.closest('input[data-child-checkbox]') : null;
    if (childInput) {
      var parentValue = childInput.getAttribute('data-parent-value');
      var parentInputs = document.querySelectorAll('input[data-parent-checkbox]');
      for (var i = 0; i < parentInputs.length; i++) {
        if (parentInputs[i].value === parentValue) {
          syncParentCheckbox(parentInputs[i]);
          break;
        }
      }
    }
  });

  // 初始化父项视觉状态
  initNestedFilterVisuals();

  // Shopify AJAX 重新渲染 #facet-filters 后重新初始化父项视觉
  var filtersEl = document.getElementById('facet-filters');
  if (filtersEl && 'MutationObserver' in window) {
    new MutationObserver(function () { initNestedFilterVisuals(); })
      .observe(filtersEl, { childList: true });
  }

})();
